import React, { useState, useEffect } from "react"
import styles from "./MultiSelectBox.module.css"

export interface MultiSelectBoxProps {
    data: { fieldName: string; value: string[] }
    onValueChange: (fieldName: string, valueArray: string[]) => void
    canEdit: boolean
    options: string[] // Holds the preset possible values
}

const MultiSelectBox: React.FC<MultiSelectBoxProps> = ({ data, onValueChange, canEdit, options }) => {
    const [values, setValues] = useState<string[]>(data.value ?? [])

    useEffect(() => {
        setValues(data.value ?? [])
    }, [data.value])

    const handleToggle = (option: string) => {
        let newValues: string[]
        if (values.includes(option)) {
            newValues = values.filter((value) => value !== option)
        } else {
            newValues = [...values, option]
        }

        setValues(newValues)
        onValueChange(data.fieldName, newValues)
    }

    const renderOption = (option: string) => {
        const isSelected = values.includes(option)
        const opacityClass = isSelected ? styles.selected : styles.unselected
        const nonEditClass = !canEdit ? styles.nonEditMode : ""

        return (
            <div key={option} className={`${styles.listItem} ${opacityClass} ${nonEditClass}`} onClick={() => canEdit && handleToggle(option)}>
                {option}
            </div>
        )
    }

    return (
        <div className={styles.list}>
            {canEdit
                ? options.map((option) => renderOption(option)) // Show all options in edit mode
                : values.map(
                      (
                          selectedValue // Show only selected values in non-edit mode
                      ) => (
                          <div key={selectedValue} className={`${styles.listItem} ${styles.selected} ${styles.nonEditMode}`}>
                              {selectedValue}
                          </div>
                      )
                  )}
        </div>
    )
}

export default MultiSelectBox
